export default __webpack_public_path__ + "static/media/superation-min.9dbb4174.jpg";